import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
  nav: {
    top: 0,
    backgroundColor: '#fff',
    position: 'sticky',
    display: 'flex',
    flexDirection: 'row',
    overflow: 'auto',
    whiteSpace: 'nowrap',
    listStyle: 'none',
    margin: '0px',
    padding: '0px',
  },
  item: {
    padding: '20px 7.5px',
    fontSize: '0.975rem',
    fontWeight: '500',
  },
  selected: {
    color: '#F97F11',
    borderBottom: '2px solid #F97F11',
  },
});

export default useStyles;
